export default "__VITE_ASSET__ff23832e__"